import { useEffect, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { provinces } from "constants/provinces";
import { cities } from "constants/cities";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import { StyledWrapper, StyledTitle, ButtonContainer } from "./Address.style";
import useHttp from "hooks/use-http";
import {
  getUserAddressByIdRequest,
  updateUserAddressRequest,
} from "api/requests";
import LoadingCM from "components/shared/Loading";
import Toast from "helper/toast";
import { editAddressUserSchema } from "validations";

////////////////////////////
const formList = [
  // {
  //   label: "استان",
  //   type: "text",
  //   id: "state",
  //   required: true,
  //   readOnly: false,
  // },
  // {
  //   label: "شهر",
  //   type: "text",
  //   id: "city",
  //   readOnly: false,
  // },
  {
    label: "کد پستی",
    type: "text",
    id: "postal_code",
    readOnly: false,
  },
  {
    label: "آدرس",
    type: "text",
    id: "address",
    readOnly: false,
  },
];

export default function UserProfile() {
  const params = useParams();
  const { request, loading, setLoading } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editAddressUserSchema),
  });

  const [userAddress, setUserAddress] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [selectedCity, setSelectedCity] = useState({});

  //////////////// FORM ////////////////
  const onSubmit = async (values) => {
    values.id = params.addressId;

    const res = await request({
      url: updateUserAddressRequest,
      values,
    });

    if (res) {
      Toast({
        type: "success",
        title: "ویرایش آدرس",
      });
    }
  };

  const getUserAddress = useCallback(async () => {
    let res = await request({
      url: getUserAddressByIdRequest,
      values: params.addressId,
      isMulty: true,
    });
    setUserAddress(res);
    setLoading(false);

    if (res) {
      reset({
        address: res.address,
        state: res.state,
        city: res.city,
        postal_code: res.postal_code,
      });
    }
  }, [request, params.addressId, reset]);

  useEffect(() => {
    getUserAddress();
  }, [getUserAddress]);

  return (
    <DrawerCM title="ویرایش آدرس">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container spacing={1}>
          <Grid item mt={3}>
            <BackButton />
          </Grid>

          <Grid item mb={3} xs={12}>
            <StyledWrapper>
              <StyledTitle>ویرایش آدرس</StyledTitle>
              <Grid container>
                <Grid item md={4} xs={12} p={1.5}>
                  <FormControl fullWidth>
                    <InputLabel id="select-state">استان</InputLabel>
                    <Select
                      labelId="select-state"
                      label="استان"
                      value={selectedState?.name}
                      defaultValue={userAddress?.state}
                      id="state"
                      {...register("state")}
                      error={Boolean(errors.state)}
                      helperText={errors.state?.message}
                      onChange={(e) =>
                        setSelectedState({
                          name: e.target.value,
                        })
                      }
                    >
                      {provinces.data?.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.name}
                          style={{
                            direction: "rtl",
                          }}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={4} xs={12} p={1.5}>
                  <FormControl fullWidth>
                    <InputLabel id="select-city">شهر</InputLabel>
                    <Select
                      label="شهر"
                      labelId="select-city"
                      value={selectedCity?.name}
                      defaultValue={userAddress?.city}
                      id="city"
                      {...register("city")}
                      error={Boolean(errors.city)}
                      helperText={errors.city?.message}
                      onChange={(e) =>
                        setSelectedCity({
                          name: e.target.name,
                        })
                      }
                    >
                      {cities.data
                        ?.filter(
                          (item) =>
                            item.province_id ===
                            provinces.data?.find((item) =>
                              selectedState.name === undefined
                                ? item.name === userAddress.state
                                : item.name === selectedState.name
                            )?.id
                        )
                        .map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.name}
                            style={{
                              direction: "rtl",
                            }}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                {formList.map((items, index) => (
                  <Grid
                    item
                    md={formList.length - 1 === index ? 12 : 4}
                    xs={12}
                    p={1.5}
                    key={"profile" + index}
                  >
                    <TextField
                      id={items.id}
                      label={items.label}
                      variant="outlined"
                      required={items.required}
                      fullWidth
                      {...register(items.id)}
                      disabled={items.disabled}
                      error={Boolean(errors[items.id])}
                      helperText={errors[items.id]?.message}
                      InputProps={{
                        readOnly: items.readOnly,
                      }}
                    />
                  </Grid>
                ))}

                <ButtonContainer>
                  <Button
                    color="success"
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ویرایش
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledWrapper>
          </Grid>

          {/* <Modal
            show={showBlockModal}
            onClose={handleBlockModal}
            title="مسدود کردن کاربر"
          >
            <StyledTextField
              id="message"
              label="دلیل مسدود سازی"
              variant="outlined"
              fullWidth
              multiline
              required
              rows={4}
              {...register("message")}
            />
            <ButtonContainer Tcenter>
              <Button
                startIcon={<BlockIcon />}
                variant="contained"
                sx={{ mt: 1 }}
                onClick={handleSubmit(onBlockUser)}
                color="warning"
              >
                مسدود کردن
              </Button>
            </ButtonContainer>
          </Modal> */}
        </Grid>
      )}
    </DrawerCM>
  );
}
